/* eslint-disable no-void */

import * as vp from 'vopay';

import { useEffect, useState } from 'react';
import axios from 'axios';

import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = {
  api: vp.Api;
};

type ReturnTuple = [vp.TransactionsHistoryResponse, (requestParams: vp.TransactionsHistoryRequest) => void, () => void];

function useFetchTransactionsFile({ api }: HookProps): ReturnTuple {
  const source = axios.CancelToken.source();
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [params, setParams] = useState<vp.TransactionsHistoryRequest>();
  const [response, setResponse] = useState<vp.TransactionsHistoryResponse>({
    ErrorMessage: '',
    Success: false,
    NumberOfRecords: 0,
    PDFFile: '',
    CSVFile: '',
    Transactions: [],
  });
  const [shouldSendRequest, setSendRequest] = useState(false);

  useEffect(() => {
    const sendRequest = async (requestParams: vp.TransactionsHistoryRequest) => {
      setDataFetchingInfo(true, 'loading some data', 'fullScreen');
      const res = await api.fetchTransactionsHistory(requestParams, source);

      setResponse(res);
      setSendRequest(false);
      setDataFetchingInfo(false);

      return () => {};
    };

    if (params && shouldSendRequest) void sendRequest(params);

    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);

  return [
    response,
    (requestParams: vp.TransactionsHistoryRequest) => {
      setParams(requestParams);
      setSendRequest(true);
    },
    () => {
      setSendRequest(false);
      setParams(undefined);
      setResponse({
        ErrorMessage: '',
        Success: false,
        NumberOfRecords: 0,
        PDFFile: '',
        CSVFile: '',
        Transactions: [],
      });
    },
  ];
}

export default vopayApi.withApiHook<HookProps, ReturnTuple>(useFetchTransactionsFile);
